// PRODUCT
export const IS_VIVUS_ONLINE = import.meta.env.VITE_PRODUCT === 'vivusonline';
export const DEFAULT_VIVUS_ONLINE_TERM = 61;

// PHONE + EMAILS

export const PHONE_VIVUSONLINE = '91 060 66 44';
export const PHONE_LINK_VIVUSONLINE = '+34910606644';

export const EMAIL_VIVUSONLINE = 'info@vivusonline.es';

// DASHBOARD ROUTES
export const LOGIN_VIVUS_ONLINE_PATH = '/online-login';
